import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MapperHeader from "./MapperHeader";
import FieldsMapper from "./FieldsMapper";
import { ConfirmationBoxV2 } from "../../../commonComponents";
// import FieldBlockMapper from "./FieldBlockMapper";
import FieldsObjectMapper from "./FieldsObjectMapper";
import DataSourceIntegrationBox from "./DataSourceIntegrationBox";
import {
  initFieldsMappingData,
  updateDataSourceSelected,
  updateDataStdioView,
  setKeyForCard,
  removeFieldMappingAction,
} from "../../../actions/FieldsSetting/fieldsSettingActions";
import { IntegrationsActions } from "../../../actions";

import { LOADING_MSG, DATA_PLAYFIELD, FIELDS } from "../../../constants";
import { FIELDS_STRING } from "../../../stringConstants";
import LZLoader from "../../../commonComponents/LZLoader";

const { getAllCRMUserData, CRMCallbackUser } = IntegrationsActions;
const { SELECT_DATASOURCE_MSG_SUBTITLE, SELECT_DATASOURCE_MSG_TITLE } =
  FIELDS_STRING;
const { FETCHING_FIELD_MAPPING } = LOADING_MSG;
const { CRM_INTEGRATIONS } = DATA_PLAYFIELD;
const { DATA_SOURCES } = FIELDS;

class DataSourceMapping extends Component {
  state = {
    searchInput: "",
    filterState: "All",
    showMenuType: "FORM",
    showChangeObjectPopup: false,
    showChangeObjectValue: null,
    showCSVFields: false,
    cardValue: "FORM",
  };

  componentDidMount() {
    const {
      currentSelectedObject,
      dataSourceSelected,
      dataStudioMappedView,
      csvData,
    } = this.props;
    if (
      !(dataSourceSelected && currentSelectedObject) &&
      dataStudioMappedView === ""
    ) {
      this.props.getAllCRMUserData();
      // this.props.getTriggerDetails();
    }
    if (
      dataSourceSelected === "csv" &&
      csvData &&
      Array.isArray(csvData.fields) &&
      csvData.fields.length > 0
    ) {
      this.toggleOnShowCSVFields();
    }
  }

  showMenu = (value, id) => {
    const { showMenuType } = this.state;
    const type = value;
    if (
      this.props.dataSourceSelected === "csv" &&
      (value === "TABLE" || value === "META")
    ) {
      return;
    }
    if (value === showMenuType || id === showMenuType) {
      id = null;
    }
    if (id === undefined) {
      id = value;
    }

    this.props.setKeyForCard(id);
    this.setState({
      cardValue: type,
      showMenuType: id,
      searchInput: "",
      filterState: "All",
    });
  };

  // showSignatoreMenu = event => {
  //   event.preventDefault();
  //   const { showSignatoreMenu } = this.state;
  //   this.setState({
  //     showSignatoreMenu: !showSignatoreMenu,
  //     // showMenu: false,
  //     showTableMenu: false,
  //   });
  // };

  // showTable = event => {
  //   event.preventDefault();
  //   const { showTableMenu } = this.state;
  //   this.setState({
  //     showTableMenu: !showTableMenu,
  //     // showMenu: false,
  //     showSignatoreMenu: false,
  //   });
  // };

  updateSearchInput = e => {
    if (e === "") {
      this.setState({
        searchInput: e,
      });
    } else {
      this.setState({
        searchInput: e.target.value,
      });
    }
  };

  updateFilterState = filterObj => {
    const { cardKey } = this.props;
    const mappedList = this.props.objectFieldsMapping.filter(
      mapping => mapping.revvFieldID === cardKey,
    );
    if (mappedList.length > 0) {
      this.setState({
        showChangeObjectValue: filterObj.label,
        showChangeObjectPopup: true,
      });
    } else {
      this.setState({
        filterState: filterObj.label,
      });
    }
  };

  closePopup = () => {
    this.setState({
      showChangeObjectPopup: false,
    });
  };

  _updateRelativeFilter = label => {
    const objMapping = this.props.objectFieldsMapping.filter(obj => {
      if (obj.revvFieldID === this.props.cardKey) {
        if (obj.revvSubField === null) {
          return obj;
        }
        if (
          this.props.revvFieldDefs[`${this.props.cardKey}-${obj.revvSubField}`]
            .sub_field &&
          obj.revvSubField ===
            this.props.revvFieldDefs[
              `${this.props.cardKey}-${obj.revvSubField}`
            ].sub_field
        ) {
          return obj;
        }
        return false;
      }
      return false;
    });

    if (Array.isArray(objMapping) && objMapping.length > 0) {
      this.props.removeFieldMappingAction(objMapping[0], this.props.templateId);
    }
    this.setState({
      filterState: label,
      showChangeObjectPopup: false,
    });
  };

  toggleOnShowCSVFields = () => {
    this.setState({
      showCSVFields: true,
    });
  };

  toggleOffShowCSVFields = () => {
    this.setState({
      showCSVFields: false,
    });
  };

  render() {
    const {
      currentSelectedObject,
      dataSourceSelected,
      isCurrDSAuthenticated,
      isCrmAuthenticated,
    } = this.props;
    const warningIcon = (
      <div>
        <FontAwesomeIcon
          icon={["far", "exclamation-triangle"]}
          className="attachment-triangle-icon "
        />{" "}
        <span>Mapping field from multiple objects is not allowed</span>
      </div>
    );
    if (
      (!dataSourceSelected ||
        !isCrmAuthenticated ||
        (dataSourceSelected && !isCurrDSAuthenticated)) &&
      dataSourceSelected !== "csv"
    ) {
      return (
        <section className="datastudio-select-header">
          <div className="col-md-8 templates-header-map-header">
            <div className="datastudio-title-wrapper">
              <div className="templateheader-title">
                {SELECT_DATASOURCE_MSG_TITLE}
              </div>
              <div className="templateheader-subtitle">
                {SELECT_DATASOURCE_MSG_SUBTITLE}
              </div>
            </div>
          </div>
          <div className="col-md-8 datastudio-integration-list">
            {CRM_INTEGRATIONS.map(data => (
              <DataSourceIntegrationBox
                key={data.id}
                data={data}
                {...this.props}
              />
            ))}
          </div>
        </section>
      );
    }
    if (
      dataSourceSelected &&
      dataSourceSelected !== "csv" &&
      !currentSelectedObject
    ) {
      return <LZLoader label={FETCHING_FIELD_MAPPING} />;
    }
    return (
      <div className="datastudio-wrapper">
        {this.state.showChangeObjectPopup && (
          <ConfirmationBoxV2
            header={warningIcon}
            subHeader={`This smart table already has fields from the ${currentSelectedObject} object mapped to some headers. If you choose fields from a different SF object, the existing mapping will be reset and lost. One smart table can have fields from one SF related object only.`}
            // loaderMessage={DELETE_ITEM}
            // showBtnLoader={showDeleteItemBtnLoader}
            closePopup={this.closePopup}
            checkboxLabel="I want to change the object."
            confirmAction={() =>
              this._updateRelativeFilter(this.state.showChangeObjectValue)
            }
            okBtnText="Change"
          />
        )}
        <div className="datastudio-object-section">
          <FieldsObjectMapper
            initFieldsMappingData={this.props.initFieldsMappingData}
            dataSourceSelected={dataSourceSelected}
            templateId={this.props.templateId}
            searchInput={this.state.searchInput}
            updateSearchInput={this.updateSearchInput}
            filterState={this.state.filterState}
            updateFilterState={this.updateFilterState}
            showMenuType={this.state.showMenuType}
            showCSVFields={this.state.showCSVFields}
            toggleOnShowCSVFields={this.toggleOnShowCSVFields}
            toggleOffShowCSVFields={this.toggleOffShowCSVFields}
            cardValue={this.state.cardValue}
          />
        </div>
        <div className="datastudio-select-header datastudio-mappper-section">
          <MapperHeader />
          {/* <FieldBlockMapper {...this.props} /> */}
          {/* Opportunity selector and Mapper */}
          <FieldsMapper
            initFieldsMappingData={this.props.initFieldsMappingData}
            dataSourceSelected={dataSourceSelected}
            templateId={this.props.templateId}
            loadingMessage={FETCHING_FIELD_MAPPING}
            showMenuType={this.state.showMenuType}
            showMenu={this.showMenu}
            searchInput={this.state.searchInput}
            filterState={this.state.filterState}
            showCSVFields={this.state.showCSVFields}
            cardValue={this.state.cardValue}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    dataSourceSelected,
    currentSelectedObject,
    cardKey,
    objectFieldsMapping,
    revvFieldDefs,
    dataStudioMappedView,
    csvData,
  } = state.FieldsSettingStore;
  const { crmAllUserConfig } = state.SettingsStore;
  let isCurrDSAuthenticated = false;
  let isCrmAuthenticated = false;
  if (Array.isArray(crmAllUserConfig) && crmAllUserConfig.length === 1) {
    isCrmAuthenticated = crmAllUserConfig[0].is_authenticated;
  }
  if (Array.isArray(crmAllUserConfig) && dataSourceSelected) {
    const dataSource = DATA_SOURCES.find(
      source => source.name === dataSourceSelected,
    );
    if (dataSource) {
      const config = crmAllUserConfig.find(
        cfg => cfg.crm === dataSource.urlRef,
      );
      if (config) {
        isCrmAuthenticated = config.is_authenticated;
        isCurrDSAuthenticated = config.is_authenticated;
      }
    }
  }
  return {
    dataSourceSelected,
    currentSelectedObject,
    isCurrDSAuthenticated,
    isCrmAuthenticated,
    cardKey,
    objectFieldsMapping,
    revvFieldDefs,
    dataStudioMappedView,
    csvData,
  };
};

const mapDispatchToProps = {
  initFieldsMappingData,
  getAllCRMUserData,
  CRMCallbackUser,
  updateDataSourceSelected,
  updateDataStdioView,
  setKeyForCard,
  removeFieldMappingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSourceMapping);
